import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TagContainer } from './styles';
import { Skeleton } from '../Skeleton';
export default function TagSkeleton({ iconOptions, label }) {
    const height = iconOptions?.size;
    return (_jsxs(TagContainer, { className: "tag-skeleton", children: [iconOptions && _jsx(Skeleton, { type: "rectangle", width: height || '20px', height: height || '20px' }), _jsx(Skeleton, { type: "rectangle", width: `${(label?.length || 0) * 8}px`, height: height || '20px' })] }));
}
//# sourceMappingURL=TagSkeleton.js.map